/*
 * Action Types
 */
export enum UtilsTypes {
  DISPATCH_ACTIONS_CHAIN_REQUEST = '@utils/DISPATCH_ACTIONS_CHAIN_REQUEST',
  DISPATCH_ACTIONS_CHAIN_SUCCESS = '@utils/DISPATCH_ACTIONS_CHAIN_SUCCESS',
  DISPATCH_ACTIONS_CHAIN_FAILURE = '@utils/DISPATCH_ACTIONS_CHAIN_FAILURE',
}

/*
 * Data types
 */

/**
 * @fields action, payload, typeSuccess, typeFailure
 */
export interface ActionsChainInterface {
  /** * action: action to be dispatched. */
  action: (arg: any) => any;
  /** * payload: action payload. */
  payload: any;
  /** * typeSuccess: type of successful action to be expected. */
  typeSuccess: string;
  /** * typeFailure: type of failure action to be expected. */
  typeFailure: string;
}

/*
 * State type
 */
export interface UtilsState {
  readonly loading: boolean;
  readonly error: boolean;
}
